import html2canvas from "html2canvas";
import JsPdf from "jspdf";
import he from "he";

export function htmlDecode(input) {
  const doc = new DOMParser().parseFromString(input, "application/xhtml+xml");
  return doc.documentElement.textContent;
}

/* 
* Para elementos com o estilo font-family: SM Infantil Pauta RRDD, esta função
* substitui espaços nos nós de texto por espaços não separáveis (&nbsp;)
* seguidos de <wbr/> para representar visualmente glifos especiais de espaço e
* permitir quebras de linha. Também garante que esses elementos tenham
* 'display: inline-block' e 'text-align: left' em seu estilo para manter o
* espaçamento e alinhamento corretos, evitando artefatos indesejados de
* justificação.
*/
function replaceSpacesforGlyphs(htmlString) {
  // Skip parsing if font-family is not found at all
  if (!/font-family\s*:\s*['"]?SM Infantil Pauta RRDD/i.test(htmlString)) {
    return htmlString;
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');

  const allElements = doc.body.querySelectorAll('*');

  allElements.forEach((el) => {
    const styleAttr = el.getAttribute('style');
    if (!styleAttr) return;

    // Check if element's font-family matches the target
    const fontMatch = styleAttr.match(/font-family\s*:\s*['"]?SM Infantil Pauta RRDD[^;'""]*/i);
    if (!fontMatch) return;

    let updatedStyle = styleAttr.trim();
    if (!updatedStyle.endsWith(';')) updatedStyle += ';';
    updatedStyle += ' display: inline-block;text-align:left;';
    el.setAttribute('style', updatedStyle);

    // Replace spaces in this element and all its descendants' text nodes
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    while (walker.nextNode()) {
      walker.currentNode.textContent = walker.currentNode.textContent.replace(/ /g, '\u00A0<wbr/>');
    }
  });

  return doc.body.innerHTML;
}


export function decodeText(input) {
  if (!input || typeof input !== "string") return input;
  let result = input;
  result = result.replace(/&amp;quot;/gm, '"');
  result = replaceSpacesforGlyphs(result);
  result = he.decode(result);
  result = result.replace(/^(font-family|font-size|color)\s*:.*;/gm, "");
  return result;
}

export function toBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

export function createPdfFromElement(elementId, filename = "download.pdf", options, x, y) {
  const input = document.getElementById(elementId);
  html2canvas(input).then(canvas => {
    const imgData = canvas.toDataURL("image/png");
    const pdf = new JsPdf(options);
    pdf.addImage(imgData, "JPEG", x, y);
    pdf.save(filename);
  });
}

export function createPdfFromQRCODE(title) {
  //eslint-disable-next-line no-undef
  const imgData = canvas.toDataURL("image/png");
  const pdf = new JsPdf({
    orientation: "p",
    unit: "px",
    format: "a4",
  });
  title && pdf.text(title, 100, 50);
  pdf.addImage(imgData, "PNG", 100, 100, 250, 250);
  pdf.save("qrCode.pdf");
}

export function treatBlankQuestionsByStudentBlock(text, blanks, answers) { 

  let blank = text.split('*');
  let finalBlank = ""; 
  let studentAnswer = "";
  let correctAnswer = "";
  let colorAnswer = "";
  let i = 0;

  blank.forEach((value, index) => {

    if (index % 2 === 0) { // If is even index is text
      finalBlank += value;

    } else if (index % 2 !== 0) { // If is odd index is blank structure

      let blank_parts = value.split(':');

      if(answers) {
        studentAnswer = answers[i] || '';
        correctAnswer = blanks
          .some(row => row
            .map(el => el.toLowerCase())
            .includes(answers[i] ? answers[i].toLowerCase() : '') 
          );
        i++;
      }

      if(correctAnswer === '' || (!correctAnswer && studentAnswer === '')) {
        colorAnswer = "bgGray";
      } else if(!correctAnswer && studentAnswer !== '') {
        colorAnswer = "bgRed";
      } else if(correctAnswer) {
        colorAnswer = "bgGreen";
      }

      // Tooltip?
      let blankTooltip = (blank_parts.length > 1 ? blank_parts[1] : false);
      finalBlank += 
        "<span class=\"blank-answer " + colorAnswer + "\"" +
          (blankTooltip ? " title=\"" + blankTooltip +  "\"" : "") + 
        ">" + (studentAnswer !== '' ? studentAnswer : '\u00A0') + "</span>";
    }
  });

  return finalBlank;
}
